import React from 'react';
import { Button } from 'antd'

import SPBreadcrumb from 'components/base/SPBreadcrumb';
import SPSearchForm from 'components/notification/csOrderList/search-form';
import SPTable from 'components/notification/csOrderList/table';
import SPDrawer from 'components/notification/csOrderList/drawer';
import OrderSPDrawer from 'components/order-management/order-list/drawer';
import SPContentWrap from 'components/carRental/base/SPContentWrap';

import { useCSOrderListTemplate } from "hooks/notification/csOrderList";

interface IPageProps {
	enums?: any;
	permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, permission } = props;

	const { tableActionView } = useCSOrderListTemplate();

	const handleOpenDrawer = () => {
		tableActionView({});
	}

	return (
		<>
			<SPBreadcrumb title="工单列表" />
			<SPContentWrap className="common-margin-top">
				<SPSearchForm enums={enums} />
			</SPContentWrap>
			<SPTable permission={permission} enums={enums} />
			<SPDrawer enums={enums}  permission={permission} />
			{/* 订单详情抽屉 */}
			<OrderSPDrawer permission={permission} enums={enums} />
		</>
	);
};

export default SPPage;
